import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Esta es la historia de lo que le ocurrió a un niño llamado Juan Martín, quien vivía en un lugar alejado. Por eso
      no iba a la escuela, no conocía a otros niños y su única obligación era llevarle el almuerzo a su padre, un
      leñador. Cuando Juan Martín volvía a casa después de que su padre hubiera almorzado, se sentaba a orillas de una
      extensa laguna de color verde rodeada de cerros.
    </p>
    <p className="content justified">
      Esta no era una laguna cualquiera, era una laguna encantada. “Todos en Colombia sabemos que los indígenas andinos
      adoraban a sus dioses en las aguas quietas”. “Tal vez por ese antiguo significado religioso que tuvieron las
      lagunas para los Chibchas, sus descendientes hemos conservado por ellas una como veneración, un cierto respeto y
      las hemos colmado de hermosas y atractivas leyendas, casi todas relacionadas con tesoros ocultos bajo el agua y
      con maravillosas fórmulas y extraordinarios procedimientos para libertarlos de su cofre líquido”.
    </p>
    <p className="content justified">
      Un día, mientras contemplaba el agua, Juan Martín escuchó hablar a un pato con un ave de largas patas, quienes
      comentaban que al día siguiente aparecerían en la laguna la Pata de oro y su familia. El niño ya conocía esta
      historia, pues su padre le había contado acerca de los patos de oro macizo y su valor.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      “Sólo el que lograra enlazarlos entre las cuentas de un rosario, todos a la vez y sin que ninguno quedara fuera
      del lazo, podría apoderarse de ellos”. Así que Juan planeó atraparlos con el rosario que su madre tenía en el
      altar.
    </p>
    <p className="content justified">
      La Pata de oro y los paticos aparecieron imponentes en la superficie de la laguna color esmeralda. Pero cuando
      Juan intentó atraparlos, el más pequeño de los patos quedó por fuera y el resto salieron despavoridos.
    </p>
    <p className="content justified">
      Juan Martín no se olvidó de esta leyenda, así que al año siguiente intentó atraparlos de nuevo y lo logró.
      Apareció a su lado una hermosa joven y siete niños, quienes le contaron que todos eran hermanos y que desde hace
      cientos de años vivían en el fondo de la laguna, en un palacio de esmeralda, lo que explicaba el hermoso color del
      agua.
    </p>
    <p className="content justified">
      Solo una vez al año salían a ver la luz del sol, pero ya no podrían volver a su palacio, pues Juan Martín había
      roto el encantamiento. La única manera de revertir este penoso suceso era que Juan se lanzara con ellos a la
      laguna y que no volviera a su casa nunca más.
    </p>
    <p className="content justified">
      “Ahora, en vez de siete paticos, son ocho los que salen una vez al año de la laguna encantada. El octavo pato es
      de color de bronce y siempre se queda de último para mirar durante más tiempo las orillas del lago sagrado”.
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">Un cuento y varias tradiciones</h3>
      <p className="content justified">
        “La laguna encantada” es un cuento sincrético donde se recopilan diferentes tradiciones literarias, como la
        europea del siglo XVI, la fantástica de los cuentos de hadas y la oralidad indígena de Colombia.
      </p>
      <p className="content justified">
        Oswaldo Díaz Díaz recurrió a las historias de las comunidades que habitaron las tierras andinas colombianas
        –como los muisca–, se basó en el imaginario europeo sobre América como una tierra maravillosa llena de leyendas
        –como El dorado–, utilizó elementos fantásticos de los cuentos de hadas –como encantamientos, metamorfosis y
        sacrificios del héroe–, para finalmente escribir uno de los relatos infantiles más bellos y conmovedores en
        1939.
      </p>
      <p className="content justified">
        Y concluye: “Si alguno de vosotros quiere verlos, tiene que averiguar el sitio de la laguna y la fecha de la
        maravillosa aparición. Yo no os lo cuento, porque en tal caso aumentaría indefinidamente el número de paticos de
        oro y en vuestras familias os echarían mucho de menos”.
      </p>
      <p className="content justified">
        Y tú, ¿ya sabes cuál es la ubicación de la laguna encantada y el día en que aparecen la Pata de oro y los
        paticos?
      </p>
    </div>
  </div>
);
